import { RootState } from '../../../stores/types';

/**
 * Returns the catalog item currently available in the global application state. Typically, this
 * item is reduced into the application state using the `fetchCatalogItemByNumber` action creator.
 */
export default function getCatalogItem(state: RootState): io.flow.v0.models.Item | undefined {
  return state.catalog.item;
}
